<template>
  <div>
    <DataListStateful
      title="Черновики поставок"
      resource="shipping-drafts"
      store="shippingDrafts"
      :columns="columns"
      row-to="shipping-new-steps"
      :allow-delete="true"
      :filter-options="filter"
      :add-route="{ name: 'shipping-new-steps' }"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        {
          title: "Автор",
          name: "author",
          dataPath: "Author.Title",
          sortable: true,
        },
        {
          title: "Дата создания",
          name: "date",
          visible: true,
          width: 65,
          maxLength: 10,
        },
        {
          title: "Менеджер",
          name: "manager",
          dataPath: "Manager.Title",
          sortable: true,
        },
        {
          title: "Клиент",
          name: "client",
          dataPath: "Client.Title",
          sortable: true,
        },
        {
          title: "Страна отправления",
          name: "country",
          dataPath: "Country.Title",
          visible: true,
          width: 85,
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Продавец",
          name: "sender",
          dataPath: "SenderFactory.Title",
        },
      ],
      filter: {
        date: {
          title: "Дата",
          type: "date",
        },
        author: {
          title: "Автор",
          type: "reference",
          resource: "users",
        },
      },
    };
  },
};
</script>
